import { DockOSD } from "lib/generated/proto/roboverse_platform_protos/statekeeping/Reported/Drone/DJI/DockOSD";

export type DockOverview = {
  networkType: string;
  networkQuality: string;
  networkRate: number;
  coverState: string;
  droneInDock: string;
  environmentTemperature: number;
  temperature: number;
  rainfall: string;
  longitude: number;
  latitude: number;
  windSpeed: number;
  workingVoltage: number;
  alarmState: string;
}

export function mapDockOsdToOverview(dockOSD: DockOSD | undefined): DockOverview | null {
  if (!dockOSD) {
    return null;
  }

  // Network Type mapping
  const getNetworkType = (type: number): string => {
    switch (type) {
      case 1: return "4G";
      case 2: return "Ethernet";
      default: return "Unknown";
    }
  };

  // Network Quality mapping
  const getNetworkQuality = (quality: number): string => {
    switch (quality) {
      case 0: return "No signal";
      case 1: return "Very Poor";
      case 2: return "Poor";
      case 3: return "Fair";
      case 4: return "Good";
      case 5: return "Excellent";
      default: return "Unknown";
    }
  };

  // Cover State mapping
  const getCoverState = (state: number): string => {
    switch (state) {
      case 0: return "Closed";
      case 1: return "Open";
      case 2: return "Half open";
      case 3: return "Cover state abnormal";
      default: return "Unknown";
    }
  };

  // Drone In Dock mapping
  const getDroneInDock = (state: number): string => {
    switch (state) {
      case 0: return "Outside the dock";
      case 1: return "Inside the dock";
      default: return "Unknown";
    }
  };

  // Rainfall mapping
  const getRainfall = (rainfall: number): string => {
    switch (rainfall) {
      case 0: return "No rain";
      case 1: return "Light rain";
      case 2: return "Moderate rain";
      case 3: return "Heavy rain";
      default: return "Unknown";
    }
  };

  // Alarm State mapping
  const getAlarmState = (state: number): string => {
    switch (state) {
      case 0: return "Disabled";
      case 1: return "Enabled";
      default: return "Unknown";
    }
  };

  return {
    networkType: getNetworkType(dockOSD.networkState?.type || 0),
    networkQuality: getNetworkQuality(dockOSD.networkState?.quality || 0),
    networkRate: dockOSD.networkState?.rate || 0,
    coverState: getCoverState(dockOSD.coverState),
    droneInDock: getDroneInDock(dockOSD.droneInDock),
    environmentTemperature: dockOSD.environmentTemperature,
    temperature: dockOSD.temperature,
    rainfall: getRainfall(dockOSD.rainfall),
    longitude: dockOSD.longitude,
    latitude: dockOSD.latitude,
    windSpeed: dockOSD.windSpeed,
    workingVoltage: dockOSD.workingVoltage,
    alarmState: getAlarmState(dockOSD.alarmState),
  };
}